export default __webpack_public_path__ + "static/media/arrow-down-circle-fill-black.a0eb4d5b.svg";